import React from 'react';
import './Navbar.css';
import logo from './logo.jpg'; // adjust path as needed

const Navbar = () => {
    return (
        <nav className="navbar">
            <img src={logo} alt="Nerdle logo" className="logo-icon" />
            <h1 className="logo-text">NERDLE</h1>
        </nav>
    );
};

export default Navbar;
